import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { IReportTemplateState } from "@/store/modules/reportTemplate/state";
import { ReportTemplateMutations } from "@/store/modules/reportTemplate/mutations";

export enum ReportTemplateActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_REPORT_TEMPLATE",
  FETCH_ALL = "FETCH_ALL_REPORT_TEMPLATE",
  FETCH_ONE = "FETCH_ONE_REPORT_TEMPLATE",
  CREATE = "CREATE_REPORT_TEMPLATE",
  DELETE = "DELETE_REPORT_TEMPLATE",
}

export const actions: ActionTree<IReportTemplateState, IRootState> = {
  async [ReportTemplateActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/reports/report/template/list", {
        params: params,
      });
      commit(ReportTemplateMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("fetch job data provider error: ", error);
    }
  },
  async [ReportTemplateActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(`/reports/report/template/${id}`);
      commit(ReportTemplateMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch role one error: ", error);
    }
  },
  async [ReportTemplateActions.CREATE]({ commit }, data) {
    const response = await baseApi.post(
      "/reports/report/template/create",
      data
    );
    return response.data.data;
  },
  async [ReportTemplateActions.DELETE]({ commit }, id: string) {
    try {
      await baseApi.delete(`/reports/report/template/delete/${id}`);
    } catch (error) {
      console.log("role delete error:", error);
    }
  },
};
